import React, { useState, useEffect, useRef } from 'react';
import CardMedia from '@material-ui/core/CardMedia';
import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import imagesAll from './../../utils/projects-handler/imagesAll';
import { SiPremierleague } from 'react-icons/si';
import "./ProjectCardMedia.css";

const ProjectCardMedia = ({ image }) => {
  const [displaySkeleton, setDisplaySkeleton] = useState("flex");
  const [displayCardMedia, setDisplayCardMedia] = useState("none");
  const cardMediaImage = imagesAll[image];
  const cardPaper = useRef()
  const divPremier = useRef()

  useEffect(() => {
    let init = localStorage.getItem("init")

    setTimeout(() => {
      setDisplaySkeleton("none");
      setDisplayCardMedia("flex");
    }, 300)

    if (!cardPaper.current) {
      return
    }

    if (init) {
      cardPaper.current.classList.add("show-band")
      divPremier.current.classList.add("show-premier")
      return
    }

    setTimeout(() => {
      if (!divPremier.current) {
        return
      }

      divPremier.current.classList.add("animation-lion")
      divPremier.current.classList.add("show-premier")
      localStorage.setItem("init", true)
    }, 1600)

    setTimeout(() => {
      if (!cardPaper.current) {
        return
      }

      cardPaper.current.classList.add("animation-band")
      cardPaper.current.classList.add("show-band")
      localStorage.setItem("init", true)
    }, 1000)
  }, []);

  return (
    <Paper elevation={2} ref={cardPaper}>
      {
        !cardMediaImage
          ? (<>
            <Skeleton variant="rect" width={340} height={230} />
            <CardMedia className="card-media" />
          </>)
          : (<>
            <Skeleton variant="rect" style={{ display: displaySkeleton }} width={340} height={230} />
            <CardMedia
              className="card-media"
              style={{ display: displayCardMedia }}
              component="img"
              height="230"
              image={cardMediaImage}
              alt="Imagen de proyecto"
            />
          </>)
      }
      <div className="premier" ref={divPremier}>
        <SiPremierleague />
      </div>
    </Paper>
  );
}

export default React.memo(ProjectCardMedia);

//explicación: la imagen se encuentra en un directorio local en este proyecto, si por algún motivo falla, nos muestra el skeleton, y el componente card media vacío es para que de entrada declare un componente con la clase card media, si no despues no lo reconoce. Si la imagen existe entonces el setTimeout hace va a hacer visible el segundo skeleton hasta que se cumplen 300ms, luego se oculta y aparece el segundo cardmedia, el cual contiene la imagen.